module.exports = __webpack_public_path__ + "img/mazda-5050-half02.0cd72a69.png";